import Section from '../Section'
import './no-promotions.scss'

const NoPromotions = () => {
  return (
    <Section className="layout__section layout__content">
      <div className="no-active-promotion">
        No hay promociones activas en el momento.
      </div>
    </Section>
  )
}

export default NoPromotions
